import { render, staticRenderFns } from "./tag-item.vue?vue&type=template&id=30537d66&scoped=true&"
import script from "./tag-item.vue?vue&type=script&lang=js&"
export * from "./tag-item.vue?vue&type=script&lang=js&"
import style0 from "./tag-item.vue?vue&type=style&index=0&id=30537d66&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30537d66",
  null
  
)

export default component.exports